<template>
  <div class="week-selector-container">
    <div class="container">
      <div class="weekbar">
        <b-form-input
          id="myweek"
          v-model="weekValue"
          type="week"
          class="form-control week-input"
          aria-label="Выбор недели"
          @change="changeWeek"
        />
        <button type="button" class="icon-btn" aria-label="Скопировать расписание в буфер обмена" title="Скопировать расписание" @click="$emit('copy')">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
          </svg>
        </button>
        <button
          type="button"
          class="icon-btn filters-toggle"
          :class="{ active: expanded || activeCount > 0 }"
          aria-label="Показать фильтры"
          :aria-expanded="expanded"
          @click="$emit('toggle-expanded')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
          </svg>
          <b-badge v-if="activeCount > 0" pill variant="warning" class="filter-count-badge">{{ activeCount }}</b-badge>
        </button>
      </div>

      <div v-show="expanded" class="filters-panel">
        <div class="filter-row">
          <label class="filter-label" for="filter-search">Поиск</label>
          <b-form-input
            id="filter-search"
            :value="search"
            type="search"
            class="form-control filter-input"
            placeholder="По названию предмета"
            aria-label="Поиск по названию предмета"
            @input="v => $emit('update:search', v)"
          />
        </div>
        <div class="filter-row">
          <label class="filter-label" for="filter-group">Группа</label>
          <b-form-select
            id="filter-group"
            :value="group"
            class="form-control filter-select"
            :options="groupOptions"
            aria-label="Фильтр по группе"
            @input="v => $emit('update:group', v)"
          />
        </div>
        <div class="filter-row">
          <label class="filter-label" for="filter-type">Тип</label>
          <b-form-select
            id="filter-type"
            :value="type"
            class="form-control filter-select"
            :options="typeOptions"
            aria-label="Фильтр по типу занятия"
            @input="v => $emit('update:type', v)"
          />
        </div>
        <button type="button" class="btn btn-outline-secondary reset-btn" :disabled="activeCount === 0" @click="$emit('reset')">
          Сбросить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
function getDateOfISOWeek(w, y) {
  var simple = new Date(y, 0, 1 + (w - 1) * 7);
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}

function getDateRangeOfWeek(w, y) {
  var date = getDateOfISOWeek(w, y);
  var start =
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2);
  date.setDate(date.getDate() + 6);
  var end =
    date.getFullYear() +
    "-" +
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2);
  return { start, end };
}

export default {
  name: "myWeekSelector",
  props: {
    search: { type: String, default: "" },
    group: { type: String, default: "" },
    type: { type: String, default: "" },
    expanded: { type: Boolean, default: false },
    groups: { type: Array, default: () => [] },
    types: { type: Array, default: () => [] },
    activeCount: { type: Number, default: 0 },
  },
  data() {
    return {
      weekValue: "",
    };
  },
  computed: {
    groupOptions() {
      return [{ text: "Все группы", value: "" }].concat(
        this.groups.map((g) => ({ text: g, value: g }))
      );
    },
    typeOptions() {
      return [{ text: "Все типы", value: "" }].concat(
        this.types.map((t) => ({ text: t, value: t }))
      );
    },
  },
  methods: {
    changeWeek(value) {
      var d = value.split("-W");
      var week = getDateRangeOfWeek(d[1], d[0]);
      this.$emit("change-week", week);
    },
  },
};
</script>

<style>
.week-selector-container {
  padding: 10px 0 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  -webkit-backdrop-filter: blur(1rem);
  backdrop-filter: blur(1rem);
  background-color: var(--navbar-bg);
  border-top: 1px solid var(--border);
  box-shadow: 0 -0.5rem 1.5rem var(--shadow);
}

.weekbar {
  display: flex;
  align-items: center;
  gap: 8px;
}
.week-input {
  flex: 1 1 auto;
}
.icon-btn {
  position: relative;
  width: 44px;
  height: 44px;
  min-width: 44px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background-color: var(--bg-elevated);
  color: var(--text);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color .15s ease, border-color .15s ease, color .15s ease;
}
.icon-btn:hover {
  background-color: var(--item-hover);
}
.icon-btn.active {
  background-color: var(--primary);
  border-color: var(--primary);
  color: var(--on-primary);
}
.filter-count-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 11px;
}

.filters-panel {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 14px;
  background-color: var(--bg-elevated);
}
.filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.filter-label {
  width: 56px;
  flex: 0 0 56px;
  margin: 0;
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 600;
}
.filter-input,
.filter-select {
  flex: 1 1 auto;
}
.reset-btn {
  width: 100%;
}
@media (max-width: 480px) {
  .filters-panel { padding: 10px; }
  .filter-label { width: 48px; flex-basis: 48px; }
}
</style>
